import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import store from "./store";
import Vant from 'vant';
import 'vant/lib/index.css';
import i18n from "@/lang";

import {
	formatTime
} from '@/utils/index';

Date.prototype.format = formatTime

Vue.use(Vant);
Vue.use(i18n);


Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
	//动态设置页面标题
	document.title = to.meta.title || "企业微信-员工自助服务";
	//动态设置页面logo
	const logoMap = {
		'4': 'ht-logo.ico',
		'5': 'gz-logo.ico'
	};
	let favicon = document.querySelector('#favicon');
	if (!favicon) {
		favicon = document.createElement('link');
		favicon.id = 'favicon';
		favicon.rel = 'icon';
		document.head.appendChild(favicon);
	}
	const type = (to.params.type || '4').toString();
	const logoName = logoMap[type];
	favicon.href = `${process.env.BASE_URL}${logoName}`

	next();
});

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app");
